import { createApp } from 'vue';
import ShareView from '../../free/ShareView.vue'

const appElements = document.querySelectorAll('.vue-share-view')

Array.from(appElements).forEach(element => {
  createApp(ShareView).mount(element);
});